$(function () { objectFitImages('.ofi') });